import React from 'react'
import { Translation, Translator } from '@morningtrain/react-translations'
import { CardWithHeaderAndButtons } from 'ui/cards/CardWithHeaderAndButtons'
import { MountSmartviewOnSelection } from '@morningtrain/react-smartviews'
import EditAmoAssessmentSmartview from 'widgets/smartviews/amo/EditAmoAssessmentSmartview'
import Button from 'ui/buttons/Button'
import { Collection } from '@morningtrain/react-resources'
import { Table } from 'widgets/crud'
import * as Columns from 'support/columns'
import * as Filters from 'support/filters'
import * as Displays from 'support/displays'
import { CountDisplay } from 'support/displays/Count'
import Permissions from 'services/Permissions'
import { Can } from '@morningtrain/react-auth'
import * as UI from 'ui'
import MountSmartviewWithModelOnClick from 'support/utilities/MountSmartviewWithModelOnClick'

export function AmoAssessments () {
  return (
    <Translator namespace='hr.amo.amo_assessment'>
      <CardWithHeaderAndButtons
        header={<Translation name='header'/>}
        buttons={
          <Can permission={Permissions.HR_MANAGE_AMO}>
            <MountSmartviewWithModelOnClick
              smartview={<EditAmoAssessmentSmartview create/>}
              replace={false}
            >
              <Button><Translation name='actions.create'/></Button>
            </MountSmartviewWithModelOnClick>
          </Can>
        }
      >
        <Collection resourceName='amo.amo_assessment'>
          <Can permission={Permissions.HR_MANAGE_AMO}>
            <MountSmartviewOnSelection smartview={<EditAmoAssessmentSmartview/>} replace={false}/>
          </Can>
          <Table className='cursor-pointer'>
            <Columns.Column
              name='departments'
              display={<CountDisplay name='department' translationName='department'/>}
              label={<Translation name='columns.departments.label'/>}
            />
            <Columns.Date
              name='created_at'
              label={<Translation name='columns.created_at.label'/>}
            />
            <Columns.Column label={<Translation name='columns.assessment'/>}>
              <Displays.DownloadFile name='assessment_url' filenameAttribute='assessment_name'>
                <UI.Text className='cursor-pointer'>
                  <Displays.Text name='assessment_name'/>
                </UI.Text>
              </Displays.DownloadFile>
            </Columns.Column>
            <Columns.Column label={<Translation name='columns.actions.label'/>}>
              <Displays.DownloadFile name='actions_url' filenameAttribute='actions_name'>
                <UI.Text className='cursor-pointer'>
                  <Displays.Text name='actions_name'/>
                </UI.Text>
              </Displays.DownloadFile>
            </Columns.Column>
          </Table>
          <Filters.PaginationFilter/>
        </Collection>
      </CardWithHeaderAndButtons>
    </Translator>
  )
}
